/**
 * Main Slider Data
 * Contains slide assets and structure
 */

// Import video assets
import video1 from '../../assets/logo/sliders/slide_1.webm';
import video2 from '../../assets/logo/sliders/slide_2.webm';
import video3 from '../../assets/logo/sliders/slide_3.webm';


export interface SlideData {
    videoSrc: string;
    subtitle: string;
    title: string;
    text: string;
}

interface SlideConfig {
    videoSrc: string;
    sliderKey: 'slider1' | 'slider2' | 'slider3';
}

/**
 * Main slider slide assets configuration
 * Translation keys are used to get translations at runtime
 */
export const MAIN_SLIDER_SLIDES: SlideConfig[] = [
    {
        videoSrc: video1,
        sliderKey: 'slider1'
    },
    {
        videoSrc: video2,
        sliderKey: 'slider2'
    },
    {
        videoSrc: video3,
        sliderKey: 'slider3'
    }
];

/**
 * Get slide data with translations
 * @param t - Translation function
 * @returns Array of slide data with translated content
 */
export function getMainSliderSlides(t: any): SlideData[] {
    return MAIN_SLIDER_SLIDES.map(slide => ({
        videoSrc: slide.videoSrc,
        subtitle: t.HERO[slide.sliderKey].subtitle,
        title: t.HERO[slide.sliderKey].title,
        text: t.HERO[slide.sliderKey].text
    }));
}

